import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, noop, map, isEqual } from 'lodash';
import StudentReportFilter from '../../../components/Filter/StudentReport.filter.component';
import ContentTable from '../../../components/ContentTable/ContentTable.component';
import ListForm from '../../../components/ListForm/ListForm.component';
import { STUDENT_UNIT_2_FORM_FIELDS } from '../../../constants/student.constant';
import {  DAFTAR_NILAI_FORM_FIELDS} from '../../../constants/kurikulum/ulangan.constant';
import { validateRequiredFields } from '../../../utils/validation.util';
import { commaFormatted, normalizeAmount, formatData } from '../../../utils/transformer.util';
import { Button } from '../../../components/base/index';
import { Input, Select, Textarea } from '../../../components/base/index';
import { MATA_PELAJARAN_LIST_TABLE_FIELDS } from '../../../constants/kurikulum/kurikulum.constant';

const initialContent = {
  loading: true,
  list: [],
  currentPage: 1,
  total: 1,
  totalPage: 1,
  error: false,
};

export default class NilaiRaportEdit extends PureComponent {
  constructor(props) {
    super(props);
    this._onFormChange = this._onFormChange.bind(this);
    this._onClickNext = this._onClickNext.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this._setForm = this._setForm.bind(this);
    this._getPeriodsOptions= this._getPeriodsOptions.bind(this);
    this._getParamOptionsAcademics = this._getParamOptionsAcademics.bind(this);
    this._onSearchContent = this._onSearchContent.bind(this);
    this._onChangeFilter = this._onChangeFilter.bind(this);
    const {user} = this.props;
    const {organizations_id} = user;

    this.state = {
      page: 1,
      selected: {},
      content: initialContent,
      unchecked: {},
      filters:{},
      list:[],
      form: {
        value: {
          organizations_id: organizations_id,
          listraport: [
            {
              score: '',
              subject_id: '',
              descriptions: '',
            }
          ],
          },
        error: {
          listraport: '',

        },
      },
      param: {},

    };
  }

  componentDidMount() {
    const { location, getLevels, getclassrooms, user } = this.props;
    const { state = {} } = location;
    const {isEdit =  false, data} = state;
    const { content } = this.state;
    const { id } = state.data || '';
    const paramTypes = ['classrooms', 'levels'];
    paramTypes.forEach((type) => {  
      this._getParamOptionsAcademics(type);
    });
    // console.log(data)
    if (isEdit) {
      if (isEmpty(content.list)) {
        this._onSearchContent({ page: 1 }, id, data);
      }
    }
    
    
    // this._getStudentOptions();
    // this._getFolderOptions();
    
    // this._getclassrooms();
    // getclassrooms();
    // getLevels();
    // if (id) {
    //   this.setState({id:id})
    //   this._handleLoadData(id)
    // }
    
    this._getPeriodsOptions();       

  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    const { state = {} } = location;
    const {isEdit =  false, data} = state;
    const { id } = state.data || '';
    if (!isEqual(prevProps, this.props)) {
      this._onSearchContent({ page: 1 });
    }
  }

  async _onSearchContent(params = {}, id, data) {
    const { filters, form} = this.state;
    const { value } = form;
    const { subject_id } = value;
    this.setState({
      content: initialContent,
    }, async () => {
      try {
        const { handleGetRaportSiswa, user} = this.props;
        const { organizations_id, school_unit } = user;
        const { units_id } = school_unit;

        if (id) {
          // const payload_classes = await handleGetRaportSiswa({ id, organizations_id: organizations_id, units_id, classrooms_id: data.classrooms_id });
          const payload = await handleGetRaportSiswa({ id, organizations_id: organizations_id, units_id, classes_id: data.classes_id });
          // console.log(payload_classes)
          this.setState({
            form: {
              value: {
                id: payload.id,
                students_id :payload.students_id,
                classrooms_id: data.classrooms_id,
                semester :payload.semester,
                classes_id: payload.classes_id,
                organizations_id : organizations_id,
                period: payload.period,
                average_value: payload.average_value,
                listraport: map(payload.listraport, detail => ({
                  subject_id: detail.subject_id,
                  name: detail.name,
                  kkm: detail.kkm,
                  score: detail.score,
                  descriptions: detail.descriptions,
                })),
              },
              error: {
                listraport: [],
              },
            },
          });
        }
      } catch (err) {
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              listraport: [],
            }
          }
        }));
      }
    });
  }

  _onChangeListAmount(event) {
    const { keywords } = this.state;
    this.setState({
      listAmount: Number(event.target.value),
    });
    this._onSearchContent({ limit: event.target.value, keywords, page: 1 });
  }

  _onChangeFilter(e) {
    const { target } = e;
    const { value, name } = target;
    this.setState(prevState => ({
      ...prevState,
      filters: {
        ...prevState.filters,
        [name]: value,
      },
    }), () => this._onSearchContent());
  }

  async _getParamOptionsAcademics(type, filters={}) {
    const { getParamOptionsAcademics, user } = this.props;
    const { organizations_id } = user;
    if (type === 'classrooms' || type === 'classrooms') {
      filters.organizations_id = organizations_id;
    } else {
      delete filters.organizations_id;
    }
    const res = await getParamOptionsAcademics(filters, type);
    console.log(res);
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        [type]: res,
      },
    }));
  }

  async onEdit() {
    const { history, handleEditLembarObsHarian } = this.props;
    const { form } = this.state;
    const { value } = form;
    let canSaveA = false;
    let canSaveB = false;
    const dataTabel = value.pelajaran;
    const dataForm = form.value;
    let a;
      await handleEditLembarObsHarian(value);
      history.push('/dashboard/kurikulum/ulangan/pengisian-lembar-observasi-harian');
    // }
    
  }

  async _getPeriodsOptions() {
    const { getPeriodsOptions } = this.props;
    const res = await getPeriodsOptions();
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        periods: res,
      },
    }));
    
  }

  async _setForm(id, data = {}) {
    const { handleGetRaportSiswa, user } = this.props;
    const { organizations_id } = user;

    try {
      const payload = await handleGetRaportSiswa({ id });
     
      this.setState({
        form: {
          value: {
            id: payload.id,
            students_id :payload.students_id,
            classrooms_id: data.classrooms_id,
            semester :payload.semester,
            organizations_id : organizations_id,
            period: payload.period,
            average_value: payload.average_value,
            listraport: map(payload.listraport, detail => ({
              subject_id: detail.subject_id,
              name: detail.name,
              kkm: detail.kkm,
              score: detail.score,
              descriptions: detail.descriptions,
            })),
            
            
          },
          error: {
            listraport: [],
          },
        },
      });
    } catch (err) {
      // err action
    }
  }

  async onSubmit() {
    const { history, handleSaveRaportSiswa } = this.props;
    const { form } = this.state;
    const { value } = form;        
    let canSaveA = false;
    const dataForm = form.value;
      await handleSaveRaportSiswa(value);
      history.push('/dashboard/kurikulum/raport/daftar-nilai-raport');
      history.go(0)
  }
  
  _onFormChange(event) {
    const { user } = this.props;
    const { organizations_id } = user;
    const {
      name,
      value,
      dataset,
      checked,
      type,
    } = event.target;
    const {
      inputType = 'text', inputArray = false, arrayPosition = 0,
      fieldName,
    } = dataset;
    this.setState((prevState) => {
      let newList = [];
      let newListError = [];
      let formattedValue = value;

      if (inputType === 'number') {
        formattedValue = normalizeAmount(value);
      }
      if (inputArray) {
        if (type === 'checkbox') {
          formattedValue = checked ? value : '';
        }
        newList = prevState.form.value[fieldName];
        newListError = prevState.form.error[fieldName] || [];
        newList[arrayPosition][name] = formattedValue;
        if (name === 'code_of_account') {
          newList[arrayPosition].isCredit = value.type;
        }
        if (!isEmpty(newListError[arrayPosition])) {
          newListError[arrayPosition][name] = '';
        }
      }
      return {
        form: {
          value: {
            ...prevState.form.value,
            ...(inputArray
              ? { [fieldName]: newList }
              : { [name]: formattedValue }),
          },
          error: {
            ...prevState.form.error,
            ...(inputArray
              ? { [fieldName]: newListError }
              : { [name]: '' }),
          },
        },
      };
    }, () => {
      if (name === 'levels_id') {
        this._getParamOptionsAcademics( 'classrooms', {levels_id: value, organizations_id });
      }
     
      // if (name === 'classes') {
      //   this._getStudentOptions({ filters: { classes_id: value.map(item => item.value)}} );
      // }
    });
  }

  _onClickNext() {
    const { history } = this.props;
    history.push('/dashboard/kesiswaan/laporan/daftar-siswa-kelas-unit');
  }
    
  
  render() {
    const { location, getLevels, getclassrooms, user } = this.props; 
    const { form, param } = this.state;     
    const { state = {} } = location;
    const {listraport} = form.value;
    const {isEdit =  false, data} = state;
    const { id } = state.data || '';
    const semester_data = [
      { label: 'Ganjil', value: 'ganjil'},
      { label: 'Genap', value: 'genap'},
    ]
    return (
      <div className="student-list">
        <div className="budget__title">
          <h1>Nilai Raport </h1>
          <hr></hr>
        </div>
        <form onSubmit={this._onSubmit}>
          <div className="result__content">
            <div className="nilai-raport__custom-form-row">
              <div className="nilai-raport__custom-form-row__field">
                <p>Nama &emsp;: {data?data.name:''}</p>
              </div>
              <div className="nilai-raport__custom-form-column__field">
                <Select
                  label="Tahun Ajaran"
                  name="period"
                  onChange={this._onFormChange}
                  placeholder="Pilihan"
                  data={param.periods}
                  value={form.value.period}
                  error={form.error.period || ''}
                />
              </div>
            </div>
            <div className="nilai-raport__custom-form-row">
              <div className="nilai-raport__custom-form-row__field">
                <p>NIS &emsp;&emsp;: {data?data.nis:''}</p>
              </div>
              <div className="nilai-raport__custom-form-column__field">
                <Select
                  name="semester"
                  label="Semester"
                  placeholder={'Pilihan'}
                  onChange={this._onFormChange}
                  data={semester_data}
                  value={form.value.semester}
                  error={form.error.semester || ''}
                />
              </div>
            </div>
            <div className="nilai-raport__custom-form-row">
              <div className="nilai-raport__custom-form-row__field">
              <p>Kelas &emsp;: {data?data.classrooms_name:''}</p>
              </div>
              <div className="nilai-raport__custom-form-column__field">
                
              </div>
            </div>
          </div>
          <br></br>
          <br></br>

          <div className="manage-registration">
            <div className="fund-request__content">
              <table className="table" >
                <thead>
                  <tr>
                    {
                        map(MATA_PELAJARAN_LIST_TABLE_FIELDS.label, (field, idx) => (
                          <th key={`table_th_${idx}`}>{field}</th>
                        ))
                      }
                  </tr>
                </thead>
                <tbody>
                {
                      map(listraport, (list, idx) => (
                        <tr key={`budget_row_${idx}`}>
                          {
                          map(MATA_PELAJARAN_LIST_TABLE_FIELDS.value, (field, fieldIdx) => {
                            if (fieldIdx === 0) {
                              return (
                                <td key={`table_index_${fieldIdx}_${idx}`}>{idx + 1}</td>
                              );
                            }
                            if (field.attribute === 'score') {
                              return (
                                <td key={`table_${fieldIdx}_${idx}`}><Input
                                type="number"
                                name="score"
                                data-input-array={true}
                                data-array-position={idx}
                                data-field-name='listraport'
                                onChange={this._onFormChange}
                                value={list.score}
                              />  </td>
                                  // {/* <Link to={'www.google.com'}>{data.hyperlink}</Link> </td> */}
                              );
                            }

                            if (field.attribute === 'descriptions') {
                              return (
                                <td key={`table_${fieldIdx}_${idx}`}><Input
                                type="text"
                                name="descriptions"
                                data-input-array={true}
                                data-array-position={idx}
                                data-field-name='listraport'
                                onChange={this._onFormChange}
                                value={list.descriptions}
                              />  </td>
                                  // {/* <Link to={'www.google.com'}>{data.hyperlink}</Link> </td> */}
                              );
                            }
        
                           
                            return (
                              <td className={(field.type === 'number') ? 'nominal' : ''} key={`table_${fieldIdx}_${idx}`}>
                                {formatData(list, field)}
                              </td>
                            );
                          })
                          }
                          {/* {this._renderButtons(list)} */}
                        </tr>
                      ))
                    }
                    {
                      <tr>

                      <td colSpan="3">
                        Nilai Rata-Rata
                      </td>
                      <td colSpan="2" >
                      <Input
                      type="number"
                      name="average_value"
                      placeholder="Pilihan"
                      onChange={this._onFormChange}
                      value={form.value.average_value}
                    />
                      </td>
                      </tr>
                    }
                </tbody>
              </table>
            </div>
          </div>
      
      
          <div className="manage-registration__footer">
            {this.state.id?
              <Button
                type="button"
                title="Update"
                onClick={this.onEdit}
              />:
              <Button
                type="button"
                title="Simpan"
                onClick={this.onSubmit}
              />
            }
          </div>
        </form>
      </div>
    );
  }
}
NilaiRaportEdit.propTypes = {
  handleGetKlapper: PropTypes.func,
  handleDeleteKlapper: PropTypes.func,
};
NilaiRaportEdit.defaultProps = {
  handleGetKlapper: noop,
  handleDeleteKlapper: noop,
};
